module.exports = __webpack_public_path__ + "static/img/m_banner4.47add45d.png";